import { useEffect, useRef } from "react";

export function useChainedScrolling() {
  const rightSideRef = useRef<HTMLDivElement>(null);
  const leftSideRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const rightSide = rightSideRef.current;
    const leftSide = leftSideRef.current;

    if (!rightSide || !leftSide) return;

    const handleWheel = (e: WheelEvent) => {
      const { deltaY } = e;
      const { scrollTop, scrollHeight, clientHeight } = rightSide;

      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

      // Only chain scroll when we're at the limits and trying to scroll further
      if ((isAtTop && deltaY < 0) || (isAtBottom && deltaY > 0)) {
        e.preventDefault();

        // Scroll the left side instead
        leftSide.scrollBy({
          top: deltaY,
          behavior: "auto",
        });
      }
    };

    // Add event listener with passive: false to allow preventDefault
    rightSide.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      rightSide.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return { rightSideRef, leftSideRef };
}
